import * as React from 'react';
import { CSVLink } from 'react-csv';
import {
  PageWrapper,
  H5,
  Tableheader,
  Tabletitle,
  // SelectExamsType,
  // SelectOption,
  Table,
  Thead,
  ColSpan1,
  ColSpan2,
  Tablerow,
  Payroll,
  Cash,
  ColSpan4,
} from './styles';
import { UpperTittleWrap, H2 } from '../signInvigilatorRecords/styles';
import { AdminHomeLoader, NoData } from '../../../../../components';
import { useQuery } from '@apollo/client';
import { FETCH_STAFF_PAYMENT } from './grapghql';
import { GetStaffsPaymentQuery } from '../../../../../generated/graphql';
import { Headers } from 'react-csv/components/CommonPropTypes';
import { toast } from 'react-toastify';
import { useExamsTypeAndSem } from '../../../../../helpers/examTypeAndSemester';
import { academicYear } from '../../../../../helpers';

export const Payment = (): JSX.Element => {
  const { loading, data, error } = useQuery<GetStaffsPaymentQuery>(FETCH_STAFF_PAYMENT);
  const examsTypeAndSemester = useExamsTypeAndSem();

  if (loading) return <AdminHomeLoader />;

  // header for excel report
  const headers: Headers = [
    { label: 'SN', key: 'sn' },
    { label: 'Name', key: 'name' },
    { label: 'Category', key: 'category' },
    { label: 'Time/hr', key: 'hours' },
    { label: 'Rate/hr', key: 'invigilationRate' },
    { label: 'Inv Amt (GHC)', key: 'invigilationAmount' },
    { label: 'Snack Amt (GHC)', key: 'snackAmt' },
    { label: 'Total (GHC)', key: 'total' },
    { label: 'Tax (%)', key: 'tax' },
    { label: 'Amount Due (GHC)', key: 'amountDue' },
    { label: 'Pay Status', key: 'payStatus' },
    { label: 'Bank branch', key: 'bankBranch' },
    { label: 'Bank Acc No.', key: 'bankAccNo' },
    { label: 'Bank name', key: 'bankName' },
  ];

  const durationInHrAndMin = (time: number): string => {
    const durationInMin = (time % 1) * 60;
    const hr = Math.floor(time);
    return `${hr} hr${hr > 1 ? 's' : ''} ${durationInMin > 0 ? `: ${durationInMin} mins` : ''}`;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const excelData: any =
    (data?.getStaffPayment &&
      data.getStaffPayment.map((obj, index) => {
        const category = obj?.category?.split('/') as string[];
        return {
          sn: index + 1,
          name: obj?.name,
          category: obj?.category,
          hours: obj?.hours,
          invigilationRate:
            category[0] === 'SM'
              ? obj?.paymentConfig?.smInvigilationRate
              : obj?.paymentConfig?.nsmInvigilationRate,
          invigilationAmount: obj?.invigilationAmt,
          snackAmt: obj?.snackAmt,
          total: obj?.total,
          tax: obj?.paymentConfig?.tax,
          amountDue: obj?.amountDue,
          payStatus: obj?.payStatus,
          bankBranch: obj?.bankBranch,
          bankAccNo: obj?.bankAccNumber,
          bankName: obj?.bankName,
        };
      })) ||
    [];

  const tableHeads = [
    <Thead key={1}>
      <ColSpan1>SN</ColSpan1>
      <ColSpan4>Name</ColSpan4>
      <ColSpan2>Category</ColSpan2>
      <ColSpan1>Time/hr</ColSpan1>
      <ColSpan1>Rate/hr</ColSpan1>
      <ColSpan1>Inv Amt</ColSpan1>
      <ColSpan1>Snack Amt</ColSpan1>
      <ColSpan1>Total</ColSpan1>
      <ColSpan1>Tax {'(%)'}</ColSpan1>
      <ColSpan1>Amt Due{'(GHC)'}</ColSpan1>
      <ColSpan2 className="ml-3">Pay Status</ColSpan2>
    </Thead>,
  ];

  return (
    <PageWrapper>
      <div className="flex items-center">
        <UpperTittleWrap>
          <H2>Current</H2>
        </UpperTittleWrap>
        <H5>Archives</H5>
      </div>
      <Tableheader>
        <div>
          <Tabletitle>Payment report</Tabletitle>
        </div>
        {/*
        todo: to added and implemented later
        <div>
          <SelectExamsType>
            <SelectOption>Select exams type</SelectOption>
            <SelectOption>Mid-semester</SelectOption>
            <SelectOption>End-of-semester</SelectOption>
            <SelectOption>Supplementary</SelectOption>
          </SelectExamsType>
        </div> */}
        <div>
          <CSVLink
            filename={`${academicYear}-${examsTypeAndSemester?.examType}-
            ${examsTypeAndSemester?.semester}-exams-payment-report.csv`}
            target={'_blank'}
            data={excelData}
            headers={headers}
            className="px-10 py-2 font-semibold hover:bg-blue-700
          bg-blue-600 text-white rounded-md"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick={(e: any) => {
              if (error || !data?.getStaffPayment) {
                e.preventDefault();
                toast.error('You can only print report when data exist!');
                return;
              }
            }}
            style={
              !data?.getStaffPayment || error ? { cursor: 'not-allowed' } : { cursor: 'pointer' }
            }
          >
            <i className="fas fa-print" /> Print Report
          </CSVLink>
        </div>
      </Tableheader>
      <Table>
        {tableHeads}
        {error || data?.getStaffPayment?.length === 0 || !data?.getStaffPayment ? (
          <NoData title="No data found!" />
        ) : (
          <div className="flex-1 h-[36rem] 2xl:h-[42rem] 2xl:pb-30 pb-96 overflow-y-auto">
            {data?.getStaffPayment?.map((_data, index) => {
              const category = _data?.category?.split('/') as string[];
              return (
                <Tablerow key={_data?._id}>
                  <ColSpan1>{index + 1}</ColSpan1>
                  <ColSpan4>{_data?.name}</ColSpan4>
                  <ColSpan2>{_data?.category}</ColSpan2>
                  <ColSpan1>{durationInHrAndMin(_data?.hours as number)}</ColSpan1>
                  <ColSpan1>
                    {category[0] === 'SM'
                      ? _data?.paymentConfig?.smInvigilationRate
                      : _data?.paymentConfig?.nsmInvigilationRate}
                  </ColSpan1>
                  <ColSpan1>{_data?.invigilationAmt}</ColSpan1>
                  <ColSpan1>{_data?.snackAmt}</ColSpan1>
                  <ColSpan1>{_data?.total}</ColSpan1>
                  <ColSpan1>{_data?.paymentConfig?.tax as number}</ColSpan1>
                  <ColSpan1>{_data?.amountDue?.toFixed(2)}</ColSpan1>
                  <ColSpan2 className="ml-3">
                    {_data?.payStatus === 'PAYROLL' ? (
                      <Payroll>{_data?.payStatus}</Payroll>
                    ) : (
                      <Cash> {_data?.payStatus}</Cash>
                    )}
                  </ColSpan2>
                </Tablerow>
              );
            })}
          </div>
        )}
      </Table>
    </PageWrapper>
  );
};
